import { atomWithStorage, createJSONStorage } from "jotai/utils";

const storage = createJSONStorage<string>(() => localStorage);

export const currentAccountIdAtom = atomWithStorage<string>(
  "accountId",
  "",
  storage
);
